module.exports = __webpack_public_path__ + "img/base_activites_montgolfiere.14dcb7ba.svg";